import { TAB_INDEX_FOCUSABLE_ONLY } from "@multiweb/reactUtils/constants";
import { OptionalTabIndex } from "@multiweb/types/react";

/**
 * Funkce vrací tab index v závislosti na `disabled`.
 * Pokud je `disabled` <code><i>true</i></code>, vrací {@link TAB_INDEX_FOCUSABLE_ONLY}.
 * Pokud je `disabled` <code><i>false</i></code>, vrací původní hodnotu `tabIndex`.
 * @param tabIndex {#link OptionalTabIndex}
 * @param disabled
 * @return {@link TAB_INDEX_FOCUSABLE_ONLY} pokud je `disabled` <code><i>true</i></code>, v opačném případě vrací `tabIndex`.
 */
export const getTabIndexBasedOnDisabled = (tabIndex: OptionalTabIndex, disabled: boolean): OptionalTabIndex => {
    return disabled ? TAB_INDEX_FOCUSABLE_ONLY : tabIndex;
};
